const ELEMENT_TAGS: Record<string, (el: HTMLElement) => Partial<any>> = {
  A: (el: HTMLElement) => ({
    type: 'link',
    url: el.getAttribute('href') || '',
    children: [],
  }),
  BLOCKQUOTE: () => ({ type: 'block-quote', children: [] }),
  H1: () => ({ type: 'heading-one', children: [] }),
  H2: () => ({ type: 'heading-two', children: [] }),
  H3: () => ({ type: 'heading-three', children: [] }),
  H4: () => ({ type: 'heading-four', children: [] }),
  H5: () => ({ type: 'heading-five', children: [] }),
  H6: () => ({ type: 'heading-six', children: [] }),
  IMG: (el: HTMLElement) => ({
    type: 'image',
    url: el.getAttribute('src') || '',
    children: [],
  }),
  LI: () => ({ type: 'list-item', children: [] }),
  OL: () => ({ type: 'numbered-list', children: [] }),
  P: () => ({ type: 'paragraph', children: [] }),
  PRE: () => ({ type: 'code-block', children: [] }),
  CODE: () => ({ type: 'code-line bg-gray-900', children: [] }),
  UL: () => ({ type: 'bulleted-list', children: [] }),
};

const TEXT_TAGS: Record<string, () => Record<string, boolean>> = {
  CODE: () => ({ code: true }),
  DEL: () => ({ strikethrough: true }),
  EM: () => ({ italic: true }),
  I: () => ({ italic: true }),
  S: () => ({ strikethrough: true }),
  STRONG: () => ({ bold: true }),
  U: () => ({ underline: true }),
};

export { ELEMENT_TAGS, TEXT_TAGS };
